// import React, { useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Box,
//   CircularProgress,
//   IconButton,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import { Link, useNavigate } from "react-router-dom";
// import LanguageIcon from "@mui/icons-material/Language"; // Planet icon
// import { useTranslation } from "react-i18next"; // i18n hook
// // Можна додати іконку книги, якщо хочеш, але поки робимо текстом
// // import AutoStoriesIcon from '@mui/icons-material/AutoStories';

// const accent = "#7A3CFF";

// // --- LANGUAGE SWITCHER COMPONENT ---
// const LanguageSwitcher = () => {
//   const { i18n } = useTranslation();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = (lng) => {
//     setAnchorEl(null);
//     if (lng) {
//       i18n.changeLanguage(lng);
//     }
//   };

//   const currentLang = i18n.language ? i18n.language.split("-")[0].toUpperCase() : "EN";

//   return (
//     <>
//       <IconButton
//         onClick={handleClick}
//         sx={{ 
//           color: "#1F1F1F", 
//           mr: 1, 
//           "&:hover": { color: accent } 
//         }}
//         aria-controls={open ? "language-menu" : undefined}
//         aria-haspopup="true"
//         aria-expanded={open ? "true" : undefined}
//       >
//         <LanguageIcon />
//         <Box component="span" sx={{ fontSize: "0.85rem", fontWeight: 600, ml: 0.5 }}>
//           {currentLang}
//         </Box>
//       </IconButton>
//       <Menu
//         id="language-menu"
//         anchorEl={anchorEl}
//         open={open}
//         onClose={() => handleClose(null)}
//         PaperProps={{
//           elevation: 3,
//           sx: { mt: 1, minWidth: 120, borderRadius: 3 }
//         }}
//       >
//         <MenuItem onClick={() => handleClose("ru")}>Русский</MenuItem>
//         <MenuItem onClick={() => handleClose("en")}>English</MenuItem>
//         <MenuItem onClick={() => handleClose("fr")}>Français</MenuItem>
//         <MenuItem onClick={() => handleClose("es")}>Español</MenuItem>
//         <MenuItem onClick={() => handleClose("de")}>Deutsch</MenuItem>
//       </Menu>
//     </>
//   );
// };

// // --- MAIN HEADER COMPONENT ---
// export default function Header() {
//   const { t } = useTranslation(); 
//   const [isWaking, setIsWaking] = useState(false);
//   const navigate = useNavigate();

//   const handleStart = () => {
//     if (window.fbq) {
//       window.fbq("track", "Lead", {
//         content_name: "Started Creation Process",
//         source: "Header Create click",
//       });
//     }
//     navigate("/stepper");
//   };

//   // --- НОВИЙ ЛОГОТИП ---
//   const Logo = () => (
//     <Box
//       component={Link}
//       to="/"
//       sx={{
//         display: "flex",
//         alignItems: "baseline", // Вирівнювання по базовій лінії тексту
//         textDecoration: "none",
//         gap: 0.5,
//         // Анімація при наведенні
//         transition: "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
//         "&:hover": {
//           transform: "scale(1.03)", // Легке збільшення
//         }
//       }}
//     >
//       {/* Частина "Cristo" - строга, темна */}
//       <Box
//         component="span"
//         sx={{
//           fontFamily: '"Nunito", "Segoe UI", sans-serif', // Округлий шрифт
//           fontWeight: 800,
//           fontSize: { xs: "1.5rem", md: "1.8rem" },
//           color: "#2D2D2D",
//           letterSpacing: "-0.5px",
//         }}
//       >
//         Cristo
//       </Box>

//       {/* Частина "Tales" - магічна, градієнтна */}
//       <Box
//         component="span"
//         sx={{
//           fontFamily: '"Nunito", "Segoe UI", sans-serif',
//           fontWeight: 900,
//           fontSize: { xs: "1.5rem", md: "1.8rem" },
//           // Магічний градієнт
//           background: "linear-gradient(135deg, #7A3CFF 0%, #A066FF 50%, #FF5C8D 100%)",
//           WebkitBackgroundClip: "text",
//           WebkitTextFillColor: "transparent",
//           letterSpacing: "-0.5px",
//           position: "relative",
//           // Декоративна крапка/іскра в кінці
//           "&::after": {
//             content: '""',
//             position: "absolute",
//             bottom: 6,
//             right: -6,
//             width: 5,
//             height: 5,
//             borderRadius: "50%",
//             bgcolor: "#FF5C8D",
//           }
//         }}
//       >
//         Tales
//       </Box>
//     </Box>
//   );

//   return (
//     <>
//       <AppBar
//         position="sticky"
//         elevation={0}
//         sx={{ bgcolor: "#FFFFFF", borderBottom: "1px solid #F0F0F5" }}
//       >
//         <Toolbar
//           sx={{
//             minHeight: { xs: 56, md: 72 },
//             px: { xs: 2, md: 4 },
//             display: "flex",
//             justifyContent: "space-between",
//           }}
//         >
//           <Logo />
          
//           <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
            
//             <LanguageSwitcher />

//             <Button
//               onClick={handleStart}
//               disabled={isWaking}
//               variant="contained"
//               sx={{
//                 borderRadius: 999,
//                 textTransform: "none",
//                 px: 3,
//                 py: 1,
//                 fontWeight: 600,
//                 bgcolor: accent,
//                 color: "#FFFFFF",
//                 "&:hover": { bgcolor: "#612EE0" },
//                 display: "inline-flex",
//                 whiteSpace: "nowrap"
//               }}
//             >
//               {isWaking ? (
//                 <CircularProgress size={24} color="inherit" />
//               ) : (
//                 t('nav.getStarted') 
//               )}
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar>
//     </>
//   );
// }




import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import LanguageIcon from "@mui/icons-material/Language"; 
import { useTranslation } from "react-i18next"; 

// --- НОВИЙ КОЛІР ---
const accent = "#FF6B6B";

// --- LANGUAGE SWITCHER COMPONENT ---
const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lng) => {
    setAnchorEl(null);
    if (lng) {
      i18n.changeLanguage(lng);
    }
  };

  const currentLang = i18n.language ? i18n.language.split("-")[0].toUpperCase() : "EN";

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{ 
          color: "#1F1F1F", 
          mr: 1, 
          "&:hover": { color: accent } 
        }}
        aria-controls={open ? "language-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <LanguageIcon />
        <Box component="span" sx={{ fontSize: "0.85rem", fontWeight: 600, ml: 0.5 }}>
          {currentLang}
        </Box>
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose(null)}
        PaperProps={{
          elevation: 3,
          sx: { mt: 1, minWidth: 120, borderRadius: 3 }
        }}
      >
        <MenuItem onClick={() => handleClose("ru")}>Русский</MenuItem>
        <MenuItem onClick={() => handleClose("en")}>English</MenuItem>
        <MenuItem onClick={() => handleClose("fr")}>Français</MenuItem>
        <MenuItem onClick={() => handleClose("es")}>Español</MenuItem>
        <MenuItem onClick={() => handleClose("de")}>Deutsch</MenuItem>
      </Menu>
    </>
  );
};

// --- MAIN HEADER COMPONENT ---
export default function Header() {
  const { t } = useTranslation(); 
  const [isWaking, setIsWaking] = useState(false);
  const navigate = useNavigate();

  const handleStart = () => {
    if (window.fbq) {
      window.fbq("track", "Lead", {
        content_name: "Started Creation Process",
        source: "Header Create click",
      });
    }
    navigate("/stepper");
  };

  // --- НОВИЙ ТЕКСТОВИЙ ЛОГОТИП (але без зайвих відступів) ---
  const Logo = () => (
    <Box
      component={Link}
      to="/"
      sx={{
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        "&:hover": { opacity: 0.9 }
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          color: "#1F1F1F", // Темний колір для Cristo
          lineHeight: 1,
          fontSize: { xs: "1.5rem", md: "1.8rem" },
          letterSpacing: "-0.5px"
        }}
      >
        Cristo
        <Box
          component="span"
          sx={{
            // Градієнт для Tales
            background: "linear-gradient(90deg, #8B5CF6 0%, #FF6B6B 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            ml: 0 // Без відступу, або мінімальний
          }}
        >
          Tales.
        </Box>
      </Typography>
    </Box>
  );

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        // Залишив старий фон і бордер, як ти просив
        sx={{ bgcolor: "#FFFFFF", borderBottom: "1px solid #F0F0F5" }}
      >
        <Toolbar
          sx={{
            // Твої старі розміри
            minHeight: { xs: 56, md: 72 },
            px: { xs: 2, md: 4 },
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Logo />
          
          <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
            
            <LanguageSwitcher />

            <Button
              onClick={handleStart}
              disabled={isWaking}
              variant="contained"
              sx={{
                borderRadius: 999, // Твій старий радіус
                textTransform: "none",
                px: 3, // Твої старі відступи
                py: 1,
                fontWeight: 600,
                bgcolor: accent, // Новий колір
                color: "#FFFFFF",
                "&:hover": { bgcolor: "#E55A5A" }, // Новий ховер (трохи темніший корал)
                display: "inline-flex",
                whiteSpace: "nowrap"
              }}
            >
              {isWaking ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                t('nav.getStarted') 
              )}
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}